module.exports = __webpack_public_path__ + "static/media/game-gameinfobutton2.27add809.png";